import './FilterToggleButtons.scss'

export default ({className, children, ...restOfProps}) => {
    return (
        <div className={`filter-toggle-buttons ${className}`} {...restOfProps}>
            {children}
        </div>
    )
}